import { theme } from '../../tokens';

// ==========================================
// STYLES DE BASE
// ==========================================
export const overlayStyles: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px',
};

export const getOverlayAnimationStyles = (isClosing?: boolean): React.CSSProperties => ({
  animation: isClosing 
    ? 'modalFadeOut 0.2s ease-out forwards'
    : 'modalFadeIn 0.2s ease-out',
});

export const modalContainerStyles: React.CSSProperties = {
  background: 'white',
  borderRadius: theme.borderRadius.lg,
  boxShadow: theme.shadows.xl,
  maxWidth: '90vw',
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
};

export const getModalContainerStyles = (
  width?: number | string,
  isClosing?: boolean
): React.CSSProperties => ({
  ...modalContainerStyles,
  width: typeof width === 'number' ? `${width}px` : width || '520px',
  animation: isClosing 
    ? 'modalSlideOut 0.2s ease-out forwards'
    : 'modalSlideIn 0.2s ease-out',
});

export const modalHeaderStyles: React.CSSProperties = {
  padding: `${theme.spacing[4]} ${theme.spacing[6]}`,
  borderBottom: `1px solid ${theme.colors.border.light}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
};

export const modalTitleStyles: React.CSSProperties = {
  fontSize: theme.fontSizes.lg,
  fontWeight: theme.fontWeights.semiBold,
  color: theme.colors.text.primary,
  lineHeight: theme.lineHeights.relaxed,
  margin: 0,
};

export const closeButtonStyles: React.CSSProperties = {
  background: 'none',
  border: 'none',
  padding: theme.spacing[2],
  cursor: 'pointer',
  borderRadius: theme.borderRadius.base,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.colors.text.secondary,
  transition: 'all 0.2s ease',
};

export const closeButtonHoverStyles: React.CSSProperties = {
  background: theme.colors.background.secondary,
  color: theme.colors.text.primary,
};

export const modalBodyStyles: React.CSSProperties = {
  padding: theme.spacing[6],
  flex: 1,
  overflowY: 'auto',
};

export const modalFooterStyles: React.CSSProperties = {
  padding: `${theme.spacing[4]} ${theme.spacing[6]}`,
  borderTop: `1px solid ${theme.colors.border.light}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing[2],
  flexShrink: 0,
};

// ==========================================
// ANIMATIONS CSS (à injecter dans le DOM)
// ==========================================
export const modalAnimationCSS = `
  @keyframes modalFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes modalFadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes modalSlideIn {
    from {
      transform: scale(0.5);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes modalSlideOut {
    from {
      transform: scale(1);
      opacity: 1;
    }
    to {
      transform: scale(0.5);
      opacity: 0;
    }
  }

  @media (max-width: 768px) {
    .modal-container {
      width: 100% !important;
      max-width: calc(100vw - 32px) !important;
    }
  }
`;
